<template>
  <footer id="footer">
    <div class="footer container-w">
      <div class="footer-content">
        <div class="footer-section">
          <div class="company-info">
            <h3 class="company-name">北京质子游戏科技有限公司</h3>
            <div class="contact-info">
              <span class="contact-item">
                <i class="icon-phone"></i>
                电话：13501077731
              </span>
              <span class="contact-item">
                <i class="icon-email"></i>
                邮箱：protongame@icloud.com
              </span>
            </div>
          </div>
        </div>
        
        <div class="footer-section">
          <div class="website-info">
            <div class="domain">
              <i class="icon-globe"></i>
              网站域名：zhizigame.com
            </div>
            <div class="address">
              <i class="icon-location"></i>
              地址：北京市朝阳区管庄双桥路8号咸宁产业园D区一层1091
            </div>
          </div>
        </div>

        <div class="footer-section">
          <div class="legal-info">
            <div class="copyright">
              Copyright © 2025 北京质子游戏科技有限公司
            </div>
            <div class="icp-record">
              <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                <i class="icon-icp"></i>
                ICP备案：京ICP备2024047002号-1
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

#footer {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #ffffff;
  border-top: 3px solid #ff6b35;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px 0 20px;
  font-family: "Microsoft YaHei", "Segoe UI", sans-serif;

  a {
    color: #ffffff;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #ffd700;
      text-decoration: underline;
    }
  }

  .footer {
    padding: 0;
  }

  .container-w {
    width: 1280px;
    margin: 0 auto;
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
  }

  .footer-section {
    flex: 1;
    padding: 0 20px;
    
    &:not(:last-child) {
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }
  }

  .company-info {
    .company-name {
      font-size: 18px;
      font-weight: bold;
      color: #ffd700;
      margin-bottom: 15px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .contact-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #e0e0e0;

      .icon-phone, .icon-email {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        background-color: #ffd700;
        border-radius: 2px;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #1e3c72;
          font-size: 10px;
          font-weight: bold;
        }
      }

      .icon-phone::before {
        content: "📞";
      }

      .icon-email::before {
        content: "✉";
      }
    }
  }

  .website-info {
    .domain, .address {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 1.5;
      color: #e0e0e0;
    }

    .icon-globe, .icon-location {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      margin-top: 2px;
      flex-shrink: 0;
      background-color: #ff6b35;
      border-radius: 50%;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 10px;
      }
    }

    .icon-globe::before {
      content: "🌐";
    }

    .icon-location::before {
      content: "📍";
    }
  }

  .legal-info {
    text-align: center;
    
    .copyright {
      font-size: 14px;
      color: #e0e0e0;
      margin-bottom: 10px;
    }

    .icp-record {
      .icp-link {
        display: inline-flex;
        align-items: center;
        padding: 6px 12px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.2);
          border-color: #ffd700;
          transform: translateY(-2px);
        }

        .icon-icp {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          background-color: #ffd700;
          border-radius: 2px;
          position: relative;

          &::before {
            content: "ICP";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #1e3c72;
            font-size: 8px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>